import React from 'react';
import { ThemeProvider } from 'styled-components';
import { XplatProvider } from '../context/XPlatContext';
import { ConfigProvider } from "../context/ConfigContext";
import { theme } from '../config/theme';
import toast, {Toaster} from "react-hot-toast";
import {IoAlertCircleSharp} from "react-icons/io5";
import {MdClose} from "react-icons/md";
import {GoCheckCircleFill} from "react-icons/go";
import {AiFillInfoCircle} from "react-icons/ai";
import { UserContextProvider } from '../context/UserContext';
import AppRoutes from './AppRoutes';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <XplatProvider>
        <ConfigProvider>
          <UserContextProvider>
            <AppRoutes />
          </UserContextProvider>
        </ConfigProvider>
      </XplatProvider>

      <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 8000
          }}
        >
          {(t) => (
            <div
              className={`relative flex items-center gap-2 p-3 rounded-lg max-w-72 shadow-2xl ${t.type === "error" ? "bg-red-50" : t.type === "success" ? "bg-green-50" : "bg-gray-50"}`}
            >
              {t.type === "error" ? (
                <IoAlertCircleSharp className="text-red-600"
                          size={28}/>) : t.type === "success" ? (
                <GoCheckCircleFill size={28} className="text-green-700"/>) : (
                <AiFillInfoCircle size={28} className="text-gray-800"/>)
              }


              <div className="flex-1 text-gray-950 text-sm">
                {typeof t.message === "function" ? t.message(t) : t.message}
              </div>
              <button
                onClick={() => toast.dismiss(t.id)}
                className="border-none cursor-pointer bg-transparent  p-1 text-base text-gray-800"
              >
                <MdClose/>
              </button>
            </div>
          )}
        </Toaster>
    </ThemeProvider>
  );
};

export default App;
